interface ContactRaw {
  id?: string | number;
  alias?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  is_favorite?: boolean;
  contact_id?: string | number;
}

export const adapterContactSimple = (contact: ContactRaw | null | undefined) => {
  return {
    id: contact?.id,
    alias: contact?.alias,
    email: contact?.email,
    name: `${contact?.first_name} ${contact?.last_name}`,
    isFavorite: contact?.is_favorite,
    contact_id: contact?.contact_id,
  };
};
